export default "__VITE_ASSET__F0Ovo1aF__"